import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance from '../axiosInstance';

function Company() {
    const [data, setData] = useState({
        company_name: '',
        company_address1: '',
        company_address2: '',
        company_city: '',
        company_phone1: '',
        company_phone2: ''
    });

    const [logoFile, setLogoFile] = useState(null);
    const [logoFilename, setLogoFilename] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [id, setId] = useState(null);
    const [originalData, setOriginalData] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosInstance.get('/billsettings/company');
                const companydata = response.data.data[0]; // ✅ pick first element from array

                console.log("dom : ", companydata);

                const userData = {
                    company_name: companydata.company_name || '',
                    company_address1: companydata.company_address1 || '',
                    company_address2: companydata.company_address2 || '',
                    company_city: companydata.company_city || '',
                    company_phone1: companydata.company_phone1 || '',
                    company_phone2: companydata.company_phone2 || ''
                };

                setData(userData);
                setOriginalData(userData);
                setId(companydata.id);
                setLogoFilename(companydata.logo_filename || '');
            } catch (error) {
                console.error('Error fetching data:', error);
                setData({});
                setOriginalData({});
            }
        };
        fetchData();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setLogoFile(e.target.files[0]);
    };

    const handleEdit = () => setIsEditing(true);

    const handleCancel = () => {
        setData(originalData);
        setIsEditing(false);
        setLogoFile(null);
    };

    const handleSave = async () => {
        try {
            // Step 1: Save billing settings (text fields)
            const formData = new FormData();
            for (let key in data) {
                formData.append(key, data[key]);
            }

            await axiosInstance.put(`/billsettings/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            // Step 2: If logo file selected, upload to company route
            let updatedLogoFilename = logoFilename;
            if (logoFile) {
                const logoFormData = new FormData();
                logoFormData.append('logo_filename', logoFile);

                const companyId = localStorage.getItem('company_id');
                const logoResponse = await axiosInstance.put(`/company/${companyId}`, logoFormData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                updatedLogoFilename = logoResponse.data?.data?.logo_filename || logoFile.name;
            }

            setIsEditing(false);
            setOriginalData(data);
            setLogoFilename(updatedLogoFilename);
            setLogoFile(null);

            // Step 3: Update localStorage
            localStorage.setItem('companyname', data.company_name);
            localStorage.setItem('address1', data.company_address1);
            localStorage.setItem('address2', data.company_address2);
            localStorage.setItem('city', data.company_city);
            localStorage.setItem('Phone1', data.company_phone1);
            localStorage.setItem('phone2', data.company_phone2);
            localStorage.setItem('company_logo', updatedLogoFilename); // ✅ correct key

        } catch (error) {
            console.error('Error saving data:', error);
        }
    };


    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Company Details</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Company</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-8">
                        <div className="card shadow-lg border-0">
                            <div className="card-header bg-primary text-white">
                                <h3 className="card-title mb-0">Manage Company Information</h3>
                            </div>
                            <div className="card-body">
                                <form>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label>Company Name</label>
                                            <input
                                                type="text"
                                                name="company_name"
                                                className="form-control"
                                                value={data.company_name}
                                                onChange={handleInputChange}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Address 1</label>
                                            <input
                                                type="text"
                                                name="company_address1"
                                                className="form-control"
                                                value={data.company_address1}
                                                onChange={handleInputChange}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Address 2</label>
                                            <input
                                                type="text"
                                                name="company_address2"
                                                className="form-control"
                                                value={data.company_address2}
                                                onChange={handleInputChange}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>City</label>
                                            <input
                                                type="text"
                                                name="company_city"
                                                className="form-control"
                                                value={data.company_city}
                                                onChange={handleInputChange}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Phone No 1</label>
                                            <input
                                                type="text"
                                                name="company_phone1"
                                                className="form-control"
                                                value={data.company_phone1}
                                                onChange={handleInputChange}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Phone No 2</label>
                                            <input
                                                type="text"
                                                name="company_phone2"
                                                className="form-control"
                                                value={data.company_phone2}
                                                onChange={handleInputChange}
                                                disabled={!isEditing}
                                            />
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label>Company Logo</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={handleFileChange}
                                                disabled={!isEditing}
                                            />
                                        </div>

                                        {logoFilename && (
                                            <div className="col-md-6 mb-3 text-center">
                                                <label>Current Logo</label>
                                                <div>
                                                    <img
                                                        src={`https://apiemiride.socialpartners.in/api/billsettings/logo/${logoFilename}`}
                                                        alt="Logo"
                                                        style={{ maxHeight: '80px', maxWidth: '150px' }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="text-right mt-4">
                                        {isEditing ? (
                                            <>
                                                <button
                                                    type="button"
                                                    className="btn btn-success mr-2"
                                                    onClick={handleSave}
                                                >
                                                    Save
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    onClick={handleCancel}
                                                >
                                                    Cancel
                                                </button>
                                            </>
                                        ) : (
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={handleEdit}
                                            >
                                                Edit
                                            </button>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Company;
